module.exports = __webpack_public_path__ + "assets/word_s2p_highlight.d6e54b39.svg";